// AI Generated file
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalize',
    standalone: false,
})
export class CapitalizePipe implements PipeTransform {
    transform (word: string): string {
        if (word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }
        return word;
    }
}
